var fails = require('../internals/fails');

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/freezing.js
// module id = 990
// module chunks = 0